const STRIP_EXTENSIONS = /\.(docx|pdf|html)$/i;
const DISPLAY_LABEL_MAX_LENGTH = 80;

export const formatBreadcrumbDisplayLabel = (label: string): string => {
  const display = label.replace(STRIP_EXTENSIONS, "").trimEnd();

  if (display.length <= DISPLAY_LABEL_MAX_LENGTH) {
    return display;
  }

  const head = Math.floor((DISPLAY_LABEL_MAX_LENGTH - 1) / 2);
  const tail = DISPLAY_LABEL_MAX_LENGTH - 1 - head;
  return `${display.slice(0, head)}…${display.slice(-tail)}`;
};
